import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { IFormProfile } from 'legacy/lut/classes/models/IFormProfile'
import { useEffect, useState } from 'react'

import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

export const getContact = async (
  source: Crud<IFormProfile>,
  filter: {
    main: TSearchParam
    additional?: TSearchParam
  }
): Promise<IFormProfile> => {
  const { main, additional } = filter

  if (main.value) {
    const filters = [
      {
        field: main.field,
        operator: Operator.EQUAL,
        value: main.value,
      },
    ]
    if (additional && additional.value) {
      filters.push({
        field: additional.field,
        operator: Operator.CONTAINS,
        value: additional.value,
      })
    }
    source.setFilter({
      logic: Logic.AND,
      filters,
    })
    const fetched = await source.fetch({ force: true, skipTotal: true })

    return fetched.items[0] || {}
  }

  return {} as IFormProfile
}

type TSearchParam = {
  field: string
  value: string
}

interface IProps {
  mainFilter: TSearchParam
  additionalFilter?: TSearchParam
  isModalOpen?: boolean // ??
  onLoadContact?: (data: IFormProfile) => void
}

export const useContactData = ({
  mainFilter,
  additionalFilter,
  isModalOpen = false,
  onLoadContact,
}: IProps) => {
  const [contact, setContact] = useState<IFormProfile>({} as IFormProfile)
  const [conWip, setConWip] = useState(false)

  useEffect(() => {
    const crudCacheKey = 'use contract data'
    const sourceContact = CrudStore.get(CrudStoreItem.ContactAllData, crudCacheKey)
    const sourceNewContact = CrudStore.get(CrudStoreItem.ContactExtData, crudCacheKey)

    const fetch = async () => {
      setConWip(true)

      let result = await getContact(sourceContact, {
        main: mainFilter,
        additional: additionalFilter,
      })
      if (!Object.keys(result).length) {
        result = await getContact(sourceNewContact, {
          main: mainFilter,
          additional: additionalFilter,
        })
      }
      setContact((contact) => ({ ...contact, ...result }))
      onLoadContact && onLoadContact(result)

      setConWip(false)
    }
    if (!isModalOpen) {
      mainFilter.value && fetch()
    }

    const unsubscribeContactAllData = CrudStore.get(CrudStoreItem.ContactAllData).subscribe(
      'change',
      () => {
        mainFilter.value && fetch()
      }
    )
    const unsubscribeContactExtData = CrudStore.get(CrudStoreItem.ContactExtData).subscribe(
      'change',
      () => {
        mainFilter.value && fetch()
      }
    )

    return () => {
      unsubscribeContactAllData && unsubscribeContactAllData()
      unsubscribeContactExtData && unsubscribeContactExtData()
    }
  }, [
    onLoadContact,
    mainFilter.value,
    mainFilter.field,
    additionalFilter?.value,
    additionalFilter?.field,
    isModalOpen,
  ])

  return { contact, conWip }
}
